import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=b4622b00&scoped=true"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=b4622b00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4622b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4622b00')) {
      api.createRecord('b4622b00', component.options)
    } else {
      api.reload('b4622b00', component.options)
    }
    module.hot.accept("./BankCard.vue?vue&type=template&id=b4622b00&scoped=true", function () {
      api.rerender('b4622b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/UserInfo/BankCard.vue"
export default component.exports